/**
 * Se o menu fica recolhido, escolhido pela pessoa. Fica no navegador (localStorage):
 * vale neste aparelho. Sem escolha (null), o menu decide pela largura da tela.
 */
const CHAVE = 'sj_menu_recolhido';

export function preferenciaRecolhido() {
  try {
    const valor = localStorage.getItem(CHAVE);
    if (valor === '1') return true;
    if (valor === '0') return false;
    return null;
  } catch (_) {
    return null;
  }
}

export function salvarPreferenciaRecolhido(recolhido) {
  try {
    localStorage.setItem(CHAVE, recolhido ? '1' : '0');
  } catch (_) {
    // Sem armazenamento, a escolha vale só até recarregar a página.
  }
}
